import { render, staticRenderFns } from "./DrugSearch.vue?vue&type=template&id=3a747dd0&"
import script from "./DrugSearch.vue?vue&type=script&lang=js&"
export * from "./DrugSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports